<template>
    <div>
        <NavButton label="About" link="/" @click.passive="onNavButtonClick" />
        <NavButton
            label="Research"
            link="/research"
            @click.passive="onNavButtonClick"
        />
        <NavButton
            label="Notes"
            link="/notes"
            @click.passive="onNavButtonClick"
        />
        <NavButton
            label="Travel"
            link="/travel"
            @click.passive="onNavButtonClick"
        />
        <NavButton
            label="Teaching"
            link="/teaching"
            @click.passive="onNavButtonClick"
        />
        <NavButton
            label="Seminar"
            link="https://locallytrivialseminar.github.io"
            use-a
            @click.passive="onNavButtonClick"
        />
        <NavButton
            label="CV"
            link="https://sachagoldman.github.io/CV/CV.pdf"
            use-a
            @click.passive="onNavButtonClick"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavButton from "@/components/navigation/NavButton.vue";

export default defineComponent({
    components: { NavButton },
    emits: ["click"],
    setup(props, context) {
        function onNavButtonClick() {
            context.emit("click");
        }

        return { onNavButtonClick };
    },
});
</script>
